import { Component, input } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmSelectImports } from '@spartan-ng/helm/select';
import { Subject } from 'rxjs';

import { TrierParPipe } from '../../../../shared/pipes/trier-par.pipe';
import { FormControlNames } from '../../../models/form-control-names.model';
import { DetailFormationsReglementairesFormGroup } from '../detail-form-groups.types';

@Component({
  selector: 'app-detail-formations-reglementaires',
  imports: [ReactiveFormsModule, BrnSelectImports, HlmSelectImports, TrierParPipe],
  templateUrl: './detail-formations-reglementaires.component.html',
})
export class DetailFormationsReglementairesComponent {
  readonly form = input.required<DetailFormationsReglementairesFormGroup>();

  items = [{ nom: 'Forma 1' }, { nom: 'Forma 2' }, { nom: 'Forma 3' }, { nom: 'Forma 4' }, { nom: 'Forma 5' }];
  formationInput$ = new Subject<string>();

  ajoutFormation(nom: string) {
    return { nom };
  }

  get formationNoms(): AbstractControl {
    return this.form().get(FormControlNames.NOM_FORMATIONS_REGLEMENTAIRES) as AbstractControl;
  }
}
